import { CRMEtapaFunil } from "./crmetapa-funil";

export class CRM {
    id: number;
    descricao: string;
    etapas: CRMEtapaFunil[];
    validaCliente: boolean = true;
    criaProjeto: boolean = true;
    ganharOpVenda: boolean = true;
    textoGanho: string;
    textoPerda: string;
    habilitaGanho: boolean;
    habilitaPerda: boolean;
    tipoFunil: number;
}